// extracted by mini-css-extract-plugin
export default {"content":"modal_content__+hpJa","label":"modal_label__GGhlg","button":"modal_button__FZvog"};